//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalSurvey',
  props: {
    confirm: { type: Function, default: () => {} },
    close: { type: Function, default: () => {} },
    isLoading: { type: Boolean, default: () => false },
  },
  data() {
    return {
      //
    }
  },
  // methods: {
  //   closeModal() {
  //     this.$emit('close-modal')
  //   },
  // },
}
